import { apiSlice } from "../../api/apiSlice";

export const acrelDashboardApi = apiSlice.injectEndpoints({
  tagTypes: ["company"],
  endpoints: (builder) => ({
    getAcrelDashboardData: builder.query({
      query: (meter_id) =>
        `/apiV2/energy-meter/device-status?combined_id=${meter_id}`,
      providesTags: ["company"],
    }),
  }),
});

export const { useGetAcrelDashboardDataQuery } = acrelDashboardApi;
